
import { Options, Vue } from 'vue-class-component';
import NewsletterService from "@/services/NewsletterService";
import EventBusService from "@/services/EventBusService";

type NewsletterTargetValue = string;
type NewsletterTargetLabel = string;
type NewsletterTarget = {
    value: NewsletterTargetValue,
    label: NewsletterTargetLabel,
};

@Options({
    name: 'NewsletterSubscribeForm',
    components: {

    },
})
export default class App extends Vue {
    renderFlag = false
    loading = false
    loadingTargets = false
    targets: Array<NewsletterTarget> = [{
        value: 'general',
        label: 'Allgemeiner buggyFit-Newsletter', // this is the only default target when targets could not be loaded
    }]
    target: string|null = 'general'
    email = ''
    success = false

    get styles() {
        return this.success ? 'opacity:0.6' : '';
    }

    get targetsRegion() {
        return (this.targets || []).filter(target => target.value.startsWith('region-'));
    }
    get targetsOther() {
        return (this.targets || []).filter(target => !target.value.startsWith('region-'));
    }

    submit() {
        if( this.loading || this.loadingTargets ) {
            return;
        }

        this.loading = true;
        return NewsletterService.subscribe(this.email, this.target || '').then(result => {
            // this.loggedIn = true;
            this.success = true;
            this.email = 'Erfolg! Bitte überprüfe deine E-Mails.'

            EventBusService.$notification({
                type: 'success',
                message: 'Noch ein kleiner Schritt und deine Anmeldung zum Newsletter ist abgeschlossen: bitte überprüfe deine E-Mails.',
            })

            this.$emit('subscribe');
            //this.result = result.data?.data || null;

            //this.error = false;
            //this.loaded = true;
        }).catch(error => {
            EventBusService.$notification({
                type: 'error',
                message: error.response.data?.error || error.response.data?.message || 'Bei deiner Anmeldung zum Newsletter ist leider ein Fehler aufgetreten.',
            });
            console.log(error.response.data);
            //this.result = null;
            if( error.response.status === 401 ) {
                // this.loggedIn = false;
                return;
            }
            //this.error = true;
        }).finally(() => this.loading = false);
    }

    loadTargets() : void {
        if( this.loadingTargets ) {
            return;
        }

        this.loadingTargets = true;
        NewsletterService.targets().then(result => {
            if( result.data?.data ) {
                this.targets = Object.entries(result.data?.data).map(([value, label]) => ({
                    value: value as string,
                    label: label as string,
                }));
            }
        }).catch(error => {
            console.log(error.response.data);

        }).finally(() => this.loadingTargets = false);
    }

    mounted() {
        this.loadTargets();
        setTimeout(() => this.renderFlag = true, 1000); // prevent elementor JS events sticking to the DOM
    }
}
